import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    image?: string;
    url?: string;
}

const SEO: React.FC<SEOProps> = ({
    title = 'Share Visuals — Create Stunning Quote & Metric Cards. Fast.',
    description = 'Generate beautiful quote cards, stats cards, and SaaS metrics in seconds. Designed for founders building in public.',
    keywords = 'share visuals, visual generator, quote card generator, stats card generator, saas update cards, build in public tools, indie hackers visuals, content creation, social media templates, metric cards, quote images',
    image = 'https://www.sharevisuals.online/og-image.jpg',
    url = 'https://www.sharevisuals.online',
}) => {
    const fullTitle = title.includes('Share Visuals') ? title : `${title} | Share Visuals`;

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="google-site-verification" content="TkbrdU4_JEogLqePsjgikyuMJu4xjQ1q6RH-U4vu6p8" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "Share Visuals",
                    "url": "https://www.sharevisuals.online",
                    "description": description,
                    "potentialAction": {
                        "@type": "SearchAction",
                        "target": "https://www.sharevisuals.online/generator?q={search_term_string}",
                        "query-input": "required name=search_term_string"
                    }
                })}
            </script>
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Share Visuals",
                    "url": "https://www.sharevisuals.online",
                    "logo": "https://www.sharevisuals.online/logo192.png",
                    "sameAs": [
                        "https://twitter.com/ShareVisuals"
                    ]
                })}
            </script>
        </Helmet>
    );
};

export default SEO;
